import { CreateCompanyPanelWebComponent } from './component/CreateCompanyPanelWebComponent';
import { WEB_COMPONENT_COMPANY_CREATE_PANEL } from '../../../webcomponents.constants';

export { CreateCompanyPanelWebComponent };

window.customElements.define(WEB_COMPONENT_COMPANY_CREATE_PANEL, CreateCompanyPanelWebComponent);
